import * as actionTypes from './actionTypes'

import appraisalItemAxios from '../../axios/appraisalItem'
import companyAxios from '../../axios/company'
import { saveFileFromResponse } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'

export const fetchAppraisalItemsByCompanyId = filterOptions => {
  return dispatch => {
    let companyId = ''
    let params = null
    if (filterOptions) {
      companyId = filterOptions.company_id ? filterOptions.company_id : ''
      params = {
        item_id: filterOptions.item_id ? filterOptions.item_id : null,
        structure_id: filterOptions.structure_id ? filterOptions.structure_id : null
      }
    }
    dispatch(fetchAppraisalItemsStart())
    companyAxios
      .get(`${companyId}/structures/items`, {
        params
      })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { data } = response.data

          const itemsWithOption = data.structures.map(str => {
            let items = str.items.map((x, index) => {
              return {
                ...x,
                index: index + 1
              }
            })
            return {
              ...str,
              items: items
            }
          })

          const dataWithOption = {
            ...data,
            structures: itemsWithOption
          }

          dispatch(fetchAppraisalItemsByCompanyIdSuccess(dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalItemsFailed(error))
      })
  }
}

export const fetchAppraisalItemsByCompanyIdSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEMS_SUCCESS,
    data
  }
}

export const fetchAppraisalItemsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEMS_START
  }
}

export const fetchAppraisalItemsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEMS_FAILED,
    errorMessage
  }
}

export const clearSelectedStructure = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_STRUCTURE_RECORD
  }
}

export const fetchAppraisalItemById = recordId => {
  return dispatch => {
    dispatch(fetchAppraisalItemByIdStart())
    appraisalItemAxios
      .get(`${recordId}`)
      .then(response => {
        if (response.status === 200 && response.data.success) {
          dispatch(fetchAppraisalItemByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalItemsFailed(error))
      })
  }
}

export const fetchAppraisalItemByIdStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_BY_ID_START
  }
}

export const fetchAppraisalItemByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedAppraisalItemRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_APPRAISAL_ITEM_RECORD
  }
}

export const createAppraisalItem = recordData => {
  return dispatch => {
    dispatch(createAppraisalItemStart())

    appraisalItemAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          const message = {
            is_success: response.data.success,
            message: response.data.message
          }
          dispatch(createAppraisalItemSuccess(message))
          dispatch(
            enqueueSnackbar({
              message: 'Appraisal Item Created',
              options: {
                variant: 'success'
              }
            })
          )
        }
        dispatch(fetchAppraisalItemsByCompanyId({ company_id: recordData.company_id }))
      })
      .catch(error => {
        dispatch(createAppraisalItemFailed(error))
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Appraisal Item field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
      })
  }
}

export const createAppraisalItemStart = () => {
  return {
    type: actionTypes.CREATE_APPRAISAL_ITEM_START
  }
}

export const createAppraisalItemSuccess = message => {
  return {
    type: actionTypes.CREATE_APPRAISAL_ITEM_SUCCESS,
    message
  }
}

export const createAppraisalItemFailed = errorMessage => {
  return {
    type: actionTypes.CREATE_APPRAISAL_ITEM_FAILED,
    errorMessage
  }
}

export const updateAppraisalItem = (recordId, recordData) => {
  return dispatch => {
    dispatch(updateAppraisalItemStart())
    appraisalItemAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        const message = {
          is_success: response.data.success,
          message: response.data.message
        }
        dispatch(
          enqueueSnackbar({
            message: 'Appraisal Item Updated',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(updateAppraisalItemSuccess(message))
        dispatch(fetchAppraisalItemsByCompanyId({ company_id: recordData.company_id }))
      })
      .catch(error => {
        dispatch(updateAppraisalItemFailed(error))
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Appraisal Item field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
      })
  }
}

export const updateAppraisalItemStart = () => {
  return {
    type: actionTypes.UPDATE_APPRAISAL_ITEM_START
  }
}

export const updateAppraisalItemSuccess = message => {
  return {
    type: actionTypes.UPDATE_APPRAISAL_ITEM_SUCCESS,
    message
  }
}

export const updateAppraisalItemFailed = errorMessage => {
  return {
    type: actionTypes.UPDATE_APPRAISAL_ITEM_FAILED,
    errorMessage
  }
}

export const deleteAppraisalItem = (recordId, companyId) => {
  return dispatch => {
    dispatch(deleteAppraisalItemStart())
    appraisalItemAxios
      .delete(`/${recordId}`)
      .then(response => {
        const message = {
          is_success: true,
          message: 'Deleted'
        }
        dispatch(
          enqueueSnackbar({
            message: 'Appraisal Item Deleted',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(deleteAppraisalItemSuccess(message))
        dispatch(fetchAppraisalItemsByCompanyId({ company_id: companyId }))
      })
      .catch(error => {
        dispatch(deleteAppraisalItemFailed(error))

        dispatch(
          enqueueSnackbar({
            message: 'Delete Appraisal Item Error',
            options: {
              variant: 'error'
            }
          })
        )
      })
  }
}

export const deleteAppraisalItemStart = () => {
  return {
    type: actionTypes.DELETE_APPRAISAL_ITEM_START
  }
}

export const deleteAppraisalItemSuccess = message => {
  return {
    type: actionTypes.DELETE_APPRAISAL_ITEM_SUCCESS,
    message
  }
}

export const deleteAppraisalItemFailed = errorMessage => {
  return {
    type: actionTypes.DELETE_APPRAISAL_ITEM_FAILED,
    errorMessage
  }
}

export const importAppraisalItem = (importFile, filterOptions) => {
  return dispatch => {
    dispatch(importAppraisalItemStart())
    let formData = new FormData()
    formData.append('file', importFile)

    appraisalItemAxios
      .post('/import', formData)
      .then(response => {
        if (response.status === 200) {
          dispatch(importAppraisalItemSuccess(response.data))
          dispatch(
            enqueueSnackbar({
              message: 'Appraisal Item Imported',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchAppraisalItemsByCompanyId(filterOptions))
        }
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Appraisal Item Imported Error',
            options: {
              variant: 'error',
              data: error.response.data.data
            }
          })
        )
        dispatch(importAppraisalItemFailed(error))
      })
  }
}

export const importAppraisalItemStart = () => {
  return {
    type: actionTypes.IMPORT_APPRAISAL_ITEMS_START
  }
}

export const importAppraisalItemSuccess = () => {
  return {
    type: actionTypes.IMPORT_APPRAISAL_ITEMS_SUCCESS
  }
}

export const importAppraisalItemFailed = errorMessage => {
  return {
    type: actionTypes.IMPORT_APPRAISAL_ITEMS_FAILED,
    errorMessage
  }
}

export const exportAppraisalItems = filterOptions => {
  return dispatch => {
    dispatch(exportAppraisalItemsStart())
    let params = null
    if (filterOptions) {
      params = {
        item_id: filterOptions.item_id ? filterOptions.item_id : null,
        structure_id: filterOptions.structure_id ? filterOptions.structure_id : null,
        company_id: filterOptions.company_id ? filterOptions.company_id : null
      }
    }
    appraisalItemAxios
      .get('/export', {
        params,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(exportAppraisalItemsSuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Appraisal Item Exported',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(exportAppraisalItemsFailed(error))
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Appraisal Item field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
      })
  }
}

export const exportAppraisalItemsStart = () => {
  return {
    type: actionTypes.EXPORT_APPRAISAL_ITEMS_START
  }
}

export const exportAppraisalItemsSuccess = () => {
  return {
    type: actionTypes.EXPORT_APPRAISAL_ITEMS_SUCCESS
  }
}

export const exportAppraisalItemsFailed = errorMessage => {
  return {
    type: actionTypes.EXPORT_APPRAISAL_ITEMS_FAILED,
    errorMessage
  }
}

export const downloadAppraisalItemTemplate = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(downloadAppraisalItemTemplateStart())
    appraisalItemAxios
      .get('/download', {
        responseType: 'blob',
        params
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)

          dispatch(downloadAppraisalItemTemplateSuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Appraisal Item Template Downloaded',
              options: {
                variant: 'success'
              }
            })
          )
        }
      })
      .catch(error => {
        dispatch(downloadAppraisalItemTemplateFailed(error))
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Appraisal Item field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.data,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
      })
  }
}

export const downloadAppraisalItemTemplateStart = () => {
  return {
    type: actionTypes.DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_START
  }
}

export const downloadAppraisalItemTemplateSuccess = () => {
  return {
    type: actionTypes.DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_SUCCESS
  }
}

export const downloadAppraisalItemTemplateFailed = errorMessage => {
  return {
    type: actionTypes.DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_FAILED,
    errorMessage
  }
}

export const fetchAppraisalItemTags = filterOptions => {
  let params = null
  if (filterOptions) {
    params = filterOptions
  }
  return dispatch => {
    dispatch(fetchAppraisalItemTagsStart())
    appraisalItemAxios
      .get('/tags', {
        params
      })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchAppraisalItemTagsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchAppraisalItemTagsFailed(error))
      })
  }
}

const fetchAppraisalItemTagsStart = () => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_TAGS_START
  }
}

const fetchAppraisalItemTagsSuccess = data => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_TAGS_SUCCESS,
    data
  }
}

const fetchAppraisalItemTagsFailed = error => {
  return {
    type: actionTypes.FETCH_APPRAISAL_ITEM_TAGS_FAILED
  }
}

export const setGantt = data => {
  return {
    type: actionTypes.APPRAISAL_SET_GANTT_CHART,
    gantt: data
  }
}
